// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 2V16H5.82046L1 19.4432V2H20ZM9.5 7.5C9.5 6.94772 9.94771 6.5 10.5 6.5C11.0523 6.5 11.5 6.94772 11.5 7.5C11.5 7.82392 11.4223 8.00753 11.3501 8.11822C11.2729 8.23684 11.1597 8.3355 11.0062 8.42305C10.8462 8.51433 10.6775 8.57513 10.4869 8.64144L10.4686 8.64778C10.3935 8.67378 10.2666 8.71774 10.1602 8.76828C10.1042 8.79486 9.98358 8.85498 9.86436 8.96014C9.74806 9.06273 9.50345 9.3263 9.50345 9.75V10.75H11.5034V10.3975C11.6536 10.3366 11.8243 10.2589 11.9972 10.1603C12.3429 9.96311 12.7288 9.66594 13.0259 9.2099C13.3282 8.74594 13.5 8.17608 13.5 7.5C13.5 5.84315 12.1569 4.5 10.5 4.5C8.84315 4.5 7.5 5.84315 7.5 7.5V8.5H9.5V7.5ZM11.5039 11.5H9.5V13.5039H11.5039V11.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.5 22.9432V4.5H21.5V19.0568L19.3205 17.5H7.5V19.5H18.6795L23.5 22.9432Z"}}]};

const QuestionnaireDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'questionnaire-double-filled',
    ref,
    icon: element,
  },
));

QuestionnaireDoubleFilledIcon.displayName = 'QuestionnaireDoubleFilledIcon';

export default QuestionnaireDoubleFilledIcon;
